<div class="page-padding">
  <!--component setup panel-->
  <div class="panel">
    <div class="panel__header">
      <!--Main header-->
      <span class="panel__header__title"> {{ Translate('Family Setup') }}</span>
    </div>


    <mat-card class="panel_search mat-card">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{ Translate('Select Existing Family') }}</span>
      </div>

      <!--form-->
      <form class="header-form">
        <div style="width:300px;">
          <mat-form-field class="header-form-full-width-spinner">
            <mat-select placeholder="{{ Translate('Family') }}" name="family_" [(ngModel)]="family" #family_="ngModel" (selectionChange)="loadFamilyDetails($event.value)">
              <mat-option [value]="0"></mat-option>
              <mat-option [value]="type.type_auto" *ngFor="let type of setupFamilyService_.availableFamilyList">
                {{type.typeid + ' | ' + type.typedesc }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
    </mat-card>

    <mat-card class="panel_search mat-card">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{ Translate('Family Details') }}</span>
      </div>

      <!--form-->
      <form class="header-form">
        <div class="rowblock">
          <div>
            <div>
              <mat-form-field class="header-form-full-width-spinner">
                <input matInput name="FamilyID_" [(ngModel)]="FamilyID" #FamilyID_="ngModel" placeholder="{{ Translate('Family ID') }}"
                       required>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="header-form-full-width-spinner">
                <input matInput name="FamilyName_" [(ngModel)]="FamilyName" #FamilyName_="ngModel" placeholder="{{ Translate('Family Name') }}"
                       required>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="header-form-full-width-spinner">
                <mat-select placeholder="{{ Translate('Family Image') }}" name="blob_auto_" [(ngModel)]="blob_auto" #blob_auto_="ngModel">
                  <mat-option [value]="0"></mat-option>
                  <mat-option [value]="type.blob_auto" *ngFor="let type of setupFamilyService_.avaiableFamilyImageList">
                    <img style="width:100px; height:50px;" [src]="type.image">
                    {{type.fileName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="ShowDistTravelledTracking" name="ShowDistTravelledTracking_" #ShowDistTravelledTracking_="ngModel"></mat-checkbox>
              <b class="padding">{{'Show Distance Travelled Tracking Option on Equipment Setup' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="ShowPropelHrsPerc" name="ShowPropelHrsPerc_" #ShowPropelHrsPerc_="ngModel"></mat-checkbox>
              <b class="padding">{{'Show Propel Hours and % on Equipment' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="ShowEqualiserBarType" name="ShowEqualiserBarType_" #ShowEqualiserBarType_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Equaliser Bar Type Fields' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="ShowTrackIntensionIndicator" name="ShowTrackIntensionIndicator_" #ShowTrackIntensionIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Track Tension Indicator Installed Fields' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showFrameConfiguration" name="showFrameConfigurationIndicator_" #showFrameConfigurationIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Frame Configuration' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showCannonType" name="showCannonTypeIndicator_" #showCannonTypeIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Cannon Type' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showBogieShim" name="showBogieShimIndicator_" #showBogieShimIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Bogie Shim' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showManualInspection" name="showManualInspectionIndicator_" #showManualInspectionIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Manual Inspection Pdf' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showTrackSag" name="showTrackSagIndicator_" #showTrackSagIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Track Sag' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showCannonExt" name="showCannonExtIndicator_" #showCannonExtIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Cannon Extension' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showScallop" name="showScallopIndicator_" #showScallopIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Scallop' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showDryJoints" name="showDryJointsIndicator_" #showDryJointsIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Dry Joints' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showNumberOfLinks" name="showNumberOfLinksIndicator_" #showNumberOfLinksIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable # of Links' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showUnderFootConditions" name="showUnderFootConditionsIndicator_" #showUnderFootConditionsIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Under Foot Conditions' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showWorkOrder" name="showWorkOrderIndicator_" #showWorkOrderIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Work Order' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showThermalImage" name="showThermalImageIndicator_" #showThermalImageIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Thermal Image' | translate | async}}</b>
            </div>
            <div style="margin: 2px 10px;">
              <mat-checkbox class="margin-right-16" [(ngModel)]="showAdditionalInspectors" name="showAdditionalInspector_" #showThermalImageIndicator_="ngModel"></mat-checkbox>
              <b class="padding">{{'Enable Additional Inspectors' | translate | async}}</b>
            </div>
            <div class="a-u-d-down-container" style="margin-top:26px;">
              <a class="button button--primary" [hidden]="!isNew">
                <i class="material-icons button__icon" [hidden]="!isNew"></i><span class="button__text" (click)="save_updateFamily()" [hidden]="!isNew">
                  {{ Translate('Add') }}
                </span>
              </a>
              <a class="button button--primary" [hidden]="isNew">
                <i class="material-icons button__icon" [hidden]="isNew"></i><span class="button__text" (click)="save_updateFamily()" [hidden]="isNew">
                  {{ Translate('Update') }}
                </span>
              </a>
              <!--<a class="button button--primary" [hidden]="isNew">
      <i class="material-icons button__icon" [hidden]="isNew">
      </i><span class="button__text" [hidden]="isNew" (click)="delete_family()">
        {{ Translate('Delete') }}
      </span>
    </a>-->
            </div>
          </div>
          <div class="image-container">
            <div class="panel__header__title" style="margin-bottom:15px">{{ Translate('Chain Image') }}</div>
            <img style="width:200px; height:200px;" *ngIf="FamilyImage_Chain" [src]="sanitize(FamilyImage_Chain)">
            <img style="width:200px; height:200px" src="../../../../../../Content/Images/chain.jpg"
                 *ngIf="!FamilyImage_Chain">
            <input style="display: none" type="file" accept="image/*" (change)="onSelectChain($event)" #fileInput_C hidden>

            <a class="button button--primary">
              <i class="material-icons button__icon"></i><span class="button__text" mat-raised-button (click)="fileInput_C.click()"> {{ Translate('Choose Chain Image') }}</span>
            </a>
            <!-- <button class="button button--primary" mat-raised-button (click)="fileInput.click()"> Choose Chain Image </button> -->
          </div>
          <div class="image-container">
            <div class="panel__header__title" style="margin-bottom:15px">{{ Translate('Frame Image') }}</div>
            <img style="width:200px; height:200px" *ngIf="FamilyImage_Frame" [src]="sanitize(FamilyImage_Frame)">
            <img style="width:200px; height:200px" src="../../../../../../Content/Images/frame.jpg"
                 *ngIf="!FamilyImage_Frame">
            <input style="display: none" type="file" accept="image/*" (change)="onSelectFrame($event)" #fileInput_F hidden>
            <a class="button button--primary">
              <i class="material-icons button__icon"></i><span class="button__text" (click)="fileInput_F.click()"> {{ Translate('Choose Frame Image') }}</span>
            </a>
          </div>
        </div>
      </form>
    </mat-card>
  </div>
</div>
